import * as React from "react";
import { styled } from "styled-components";

import { Button, Grid, Spacer, Text } from "@vericus/cadmus-ui";

import UnauthorisedImg from "assets/errors/unauthorised.png";
import { useNavigate } from "react-router-dom";

import client from "@/client/apollo";

const LOGOUT_ENDPOINT = `${import.meta.env.VITE_API_ENDPOINT}/auth/logout`;

/** Logout confirmation page with a chance to Cancel and go back */
export function Logout() {
  const [working, setWorking] = React.useState(false);

  const navigate = useNavigate();

  // Ask pantheon to drop the session
  const onLogout = async () => {
    setWorking(true);
    await client.clearStore();
    await fetch(LOGOUT_ENDPOINT, { method: "POST", credentials: "include" });
    navigate("/goodbye");
  };

  return (
    <Grid>
      <GridImg
        src={UnauthorisedImg}
        alt="An illustration of a woman reading a map"
      />

      <GridContent>
        <Text kind="displayTwo">Log out of Cadmus?</Text>
        <Text kind="lead">
          Your login information will be cleared from this browser. You can log
          back into your Cadmus Assessment through your University LMS.
        </Text>
        <Spacer spacing={27} />
        <Button
          onClick={() => {
            navigate(-1);
          }}
          disabled={working}
        >
          Cancel
        </Button>
        <Button
          kind="secondary"
          marginLeft={18}
          onClick={onLogout}
          disabled={working}
        >
          Log out
        </Button>
        <Spacer spacing={72} />
      </GridContent>
    </Grid>
  );
}

const GridImg = styled.img`
  grid-column: 3 / span 5;
  width: 100%;
  margin-top: 72px;

  @media screen and (max-width: 900px) {
    grid-column: 2 / span 7;
  }

  @media screen and (max-width: 630px) {
    grid-column: 1 / span 9;
  }
`;

const GridContent = styled.div`
  grid-column: 3 / span 5;
  text-align: center;
  margin-top: 18px;

  @media screen and (max-width: 900px) {
    grid-column: 1 / span 9;
  }
`;
